import CompetencyMapsList from "pages/CompetencyMaps/list";
import { createBrowserRouter } from "react-router-dom";
// import KnowledgeBlocksList from "pages/KnowledgeBlocks/list";
import ROUTES from "constants/routes";
import ExaminationLayout from "layout/ExaminationLayout";
import CandidateListPage from "pages/Candidate/list";
import CandidateView from "pages/Candidate/view";
import CompanyPage from "pages/Company";
import CompanyInvitePage from "pages/CompanyInvite";
import CompetencyMapGenerationPage from "pages/CompetencyMaps/generation";
import CompetencyMapView from "pages/CompetencyMaps/view";
import ForgotPasswordPage from "pages/ForgotPassword";
import KnowledgeBlockView from "pages/KnowledgeBlocks/view";
import Login from "pages/Login";
import NoCompanyPage from "pages/Login/NoCompany";
import SelectCompanyPage from "pages/Login/SelectCompany";
import ProfilePage from "pages/Profile";
import QuestionView from "pages/Question/view";
import CompanyRegister from "pages/Register/CompanyRegister";
import UserRegister from "pages/Register/UserRegister";
import ResetPasswordPage from "pages/ResetPassword";
import SkillView from "pages/Skill/view";
import TestingList from "pages/Testing/list";
import ExaminationView from "pages/Testing/view/Group";
import TestingView from "pages/Testing/view/Personal";
import VacanciesList from "pages/Vacancies/list";
import VacancyView from "pages/Vacancies/view";
import MainLayout from "./layout/MainLayout";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: ROUTES.LOGIN,
        element: <Login />,
      },
      {
        path: ROUTES.SELECT_COMPANY,
        element: <SelectCompanyPage />,
      },
      {
        path: ROUTES.FORGOT_PASSWORD,
        element: <ForgotPasswordPage />,
      },
      {
        path: ROUTES.RESET_PASSWORD,
        element: <ResetPasswordPage />,
      },
      {
        path: ROUTES.NO_COMPANY,
        element: <NoCompanyPage />,
      },
      {
        path: ROUTES.USER_REGISTER,
        element: <UserRegister />,
      },
      {
        path: ROUTES.COMPANY_REGISTER,
        element: <CompanyRegister />,
      },
      {
        path: ROUTES.COMPANY_INVITE,
        element: <CompanyInvitePage />,
      },
      {
        path: ROUTES.COMPANY,
        element: <CompanyPage />,
      },
      {
        path: ROUTES.PROFILE,
        element: <ProfilePage />,
      },
      {
        path: ROUTES.COMPETENCE_MAPS,
        children: [
          {
            index: true,
            element: <CompetencyMapsList />,
          },
          {
            path: "view/:mapId",
            element: <CompetencyMapView />,
          },
          {
            path: "generation",
            element: <CompetencyMapGenerationPage />,
          },
          {
            path: "create",
            element: <CompetencyMapView />,
          },
        ],
      },
      // TODO: вернуть при интеграции
      // {
      //   path: ROUTES.SCENARIOS,
      //   children: [
      //     {
      //       index: true,
      //       element: <ScenarioList />,
      //     },
      //     {
      //       path: "view/:scenarioId",
      //       element: <ScenarioView />,
      //     },
      //     {
      //       path: "create",
      //       element: <ScenarioView />,
      //     },
      //   ],
      // },
      {
        path: ROUTES.KNOWLEDGE_BLOCKS,
        children: [
          // TODO: при отсутствии index: true отображается пустая страница, то же самое с ROUTES.SKILL, пофиксить
          // TODO: завершить скрытие страницы
          // {
          //   index: true,
          //   element: <KnowledgeBlocksList />,
          // },
          {
            path: "view/:knowledgeBlockId",
            element: <KnowledgeBlockView />,
          },
          {
            path: "create",
            element: <KnowledgeBlockView />,
          },
        ],
      },
      {
        path: ROUTES.TESTING,
        children: [
          {
            index: true,
            element: <TestingList />,
          },
          {
            element: <ExaminationLayout />,
            children: [
              {
                path: "view/personal/:id",
                element: <TestingView />,
              },
              {
                path: "create/personal",
                element: <TestingView />,
              },
              {
                path: "view/group/:id",
                element: <ExaminationView />,
              },
              {
                path: "create/group",
                element: <ExaminationView />,
              },
            ],
          },
        ],
      },
      {
        path: ROUTES.SKILL,
        children: [
          {
            path: "view/:skillId",
            element: <SkillView />,
          },
          {
            path: "create",
            element: <SkillView />,
          },
        ],
      },
      {
        path: ROUTES.CANDIDATE,
        children: [
          {
            index: true,
            element: <CandidateListPage />,
          },
          {
            path: "view/:candidateId",
            element: <CandidateView />,
          },
          {
            path: "create",
            element: <CandidateView />,
          },
        ],
      },
      {
        path: ROUTES.QUESTION,
        children: [
          {
            path: "view/:id",
            element: <QuestionView />,
          },
          {
            path: "create",
            element: <QuestionView />,
          },
        ],
      },
      {
        path: ROUTES.VACANCIES,
        children: [
          {
            index: true,
            element: <VacanciesList />,
          },
          {
            path: "view/:vacancyId",
            element: <VacancyView />,
          },
          {
            path: "create",
            element: <VacancyView />,
          },
        ],
      },
    ],
  },
]);

export default router;
